import { render, staticRenderFns } from "./ConversationCard.vue?vue&type=template&id=3bdde586&scoped=true&"
import script from "./ConversationCard.vue?vue&type=script&lang=js&"
export * from "./ConversationCard.vue?vue&type=script&lang=js&"
import style0 from "./ConversationCard.vue?vue&type=style&index=0&id=3bdde586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdde586",
  null
  
)

export default component.exports